
      var _path, _rect, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgOtp = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 120,
  height: 120,
  viewBox: "0 0 120 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M80.393 41.084V19.713a7.5 7.5 0 0 0-7.5-7.5H28.159a7.5 7.5 0 0 0-7.5 7.5v80.574a7.5 7.5 0 0 0 7.5 7.5h44.734a7.5 7.5 0 0 0 7.5-7.5V86.734",
  stroke: "#000"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 56.499,
  y: 25.156,
  width: 11.947,
  height: 4.38,
  rx: 2.19,
  transform: "rotate(-180 56.499 25.156)",
  fill: "var(--theme-primary, #810ea9)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M90.846 48.691H47.103a7 7 0 0 0-7 7v16.578a7 7 0 0 0 7 7h1.827a2 2 0 0 1 2 2v5.623c0 1.442 1.793 2.164 2.841 1.144l8.435-8.2a2 2 0 0 1 1.394-.567h27.246a7 7 0 0 0 7-7V55.691a7 7 0 0 0-7-7z",
  stroke: "#000"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M56.865 63.554c-2.963.697-3.485 1.261-4.127 4.47-.644-3.21-1.164-3.774-4.128-4.47 2.963-.697 3.484-1.26 4.127-4.471.643 3.21 1.164 3.775 4.127 4.47zm16.255 0c-2.963.697-3.485 1.261-4.127 4.47-.644-3.21-1.165-3.774-4.128-4.47 2.963-.697 3.484-1.26 4.127-4.471.643 3.21 1.164 3.775 4.127 4.47zm16.254 0c-2.963.697-3.485 1.261-4.128 4.47-.643-3.21-1.164-3.774-4.127-4.47 2.963-.697 3.484-1.26 4.127-4.471.643 3.21 1.164 3.775 4.127 4.47z",
  fill: "var(--theme-primary, #810ea9)",
  stroke: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg className='iconTop' width='120' height='120' viewBox='0 0 120 120' fill='none' xmlns='http://www.w3.org/2000/svg'>\r\n      <path\r\n        d='M80.393 41.084V19.713a7.5 7.5 0 0 0-7.5-7.5H28.159a7.5 7.5 0 0 0-7.5 7.5v80.574a7.5 7.5 0 0 0 7.5 7.5H72.893a7.5 7.5 0 0 0 7.5-7.5V86.734'\r\n        stroke='#000'\r\n        strokeWidth='2.5'\r\n        strokeLinecap='round'\r\n        strokeLinejoin='round'\r\n      />\r\n      <rect x='56.499' y='25.156' width='11.947' height='4.38' rx='2.19' transform='rotate(-180 56.499 25.156)' fill='var(--theme-primary, #810ea9)' />\r\n      <path\r\n        d='M90.846 48.691H47.103a7 7 0 0 0-7 7v16.578a7 7 0 0 0 7 7h1.827a2 2 0 0 1 2 2v5.623c0 1.442 1.793 2.164 2.841 1.144l8.435-8.2a2 2 0 0 1 1.394-.567h27.246a7 7 0 0 0 7-7V55.691a7 7 0 0 0-7-7z'\r\n        stroke='#000'\r\n        strokeWidth='2.5'\r\n      />\r\n      <path\r\n        d='M56.865 63.554c-2.963.697-3.485 1.261-4.127 4.47-.644-3.21-1.164-3.774-4.128-4.47 2.963-.697 3.484-1.26 4.127-4.471.643 3.21 1.164 3.775 4.127 4.47zM73.12 63.554c-2.963.697-3.485 1.261-4.127 4.47-.644-3.21-1.165-3.774-4.128-4.47 2.963-.697 3.484-1.26 4.127-4.471.643 3.21 1.164 3.775 4.127 4.47zM89.374 63.554c-2.963.697-3.485 1.261-4.128 4.47-.643-3.21-1.164-3.774-4.127-4.47 2.963-.697 3.484-1.26 4.127-4.471.643 3.21 1.164 3.775 4.127 4.47z'\r\n        fill='var(--theme-primary, #810ea9)'\r\n        stroke='var(--theme-primary, #810ea9)'\r\n        strokeWidth='.75'\r\n        strokeLinejoin='round'\r\n      />\r\n    </svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/OTP.0cdf435e6282441816c789f112f1d09a.svg"),
        {
          React: SvgOtp,
          svgClassName: "iconTop",
          svg: __getSvg,
          bg: __getBg
        }
      );
      